import { createRouter as createAdminRouter } from './admin';
import { createRouter as createPlatformRouter } from './platform';
import { createRouter as createReferralJamRouter } from './referralJam';

export function createRouter({ hostname }) {
  const isServer = process.env.VUE_ENV === 'server';
  const isAdminSite = !isServer && (process.env.ADMIN_UI || hostname === 'admin.reallinks.io' || hostname === 'admin.reallinks.dev');
  const isStandaloneReferralJamSite = hostname === 'referraljam.io' || `${hostname}`.endsWith('.referraljam.io');

  if (isAdminSite) {
    return createAdminRouter();
  } else if (isStandaloneReferralJamSite) {
    return createReferralJamRouter();
  } else {
    return createPlatformRouter();
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js